module.exports = require('./textCompare')
